import type { KeyboardEvent } from "react";

/**
 * Returns props to make a non-interactive element keyboard-accessible.
 * Adds role="button", tabIndex={0}, and an onKeyDown that triggers the
 * callback on Enter or Space (matching native button behaviour).
 */
export function clickableProps(onClick: (...args: any[]) => void) {
  return {
    role: "button" as const,
    tabIndex: 0,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    },
  };
}
